import '../../registration/view/OnboardingForm.less';

import React from 'react';
import { set2FAContext, tx2FA$ } from '../index';
import { useReframe } from 'nike-re-framejs';
import { METHOD_2FA_GRID, METHOD_2FA_SMS } from './method';

import TwoFactorVerify from './TwoFactorVerify';
import TwoFactorVerFailed from '../TwoFactorVerFailed';
import TwoFactorVerSuccess from '../TwoFactorVerSuccess';
import { createDialog, openDialog } from '../../dialogs/dialogs';
import { nuiCtx } from '../../../common/initialization';
import clsx from 'clsx';
import './Wizard2FA.less';

function Wizard2FA({ onClose }) {
    const { subscribe } = useReframe();
    const tx = subscribe(tx2FA$) || {};

    if (tx.error) {
        return <TwoFactorVerFailed error={tx.error} onClose={onClose} />;
    }
    if (!tx.token && (!tx.method || tx.method === METHOD_2FA_SMS || tx.method === METHOD_2FA_GRID)) {
        return <TwoFactorVerify />;
    }
    if (tx.token) {
        return <TwoFactorVerSuccess token={tx.token} onClose={onClose} />;
    }
    return null;
}

export const Dialog2FA = createDialog({
    name: 'nui-wizard-2fa',
    component: ({ close }) => {
        const { NuiDialog } = nuiCtx.components;
        return (
            <NuiDialog
                name="nui-wizard-2fa"
                className={clsx({ 'nui-wizard-2fa-portal': nuiCtx.platform === 'portal' })}
            >
                <Wizard2FA onClose={close} />
            </NuiDialog>
        );
    }
});

export function start2FA(jwt, methods, reason, payload, loginCallback) {
    return db => [
        () => set2FAContext(jwt, methods, reason, payload, loginCallback),
        () => openDialog(Dialog2FA),
        db.deleteIn(['2FA'])
    ];
}

export default Wizard2FA;
